import { FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import { handleBasicsChange } from "../../../Redux/reducers/questionSlice";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { no_validation_types } from "../questionTypes";
import ProfileAttribute from "./profileAttribute";
import CanonicalQuestionMapper from "./CanonicalQuestionMapper";

type Props = {
  question: any;
};
export const AdvancedTab = ({ question }: Props) => {
  const dispatch = useAppDispatch();

  const isPreview = useAppSelector(({ question }) => !question.editable);
  const formLevel = useAppSelector(({ question }) => question.formLevel);

  const onChange = (
    key: string,
    value: string | boolean,
    isProp?: boolean,
    convertToNum?: boolean
  ) => {
    if (!isPreview)
      dispatch(
        handleBasicsChange({
          key,
          value,
          isProp,
          convertToNum,
        })
      );
  };

  return (
    <Stack gap={2} py={1}>
      {["text", "number", "slider", "date"].includes(question.type) && (
        <Stack gap={1}>
          <FormControlLabel
            disabled={isPreview}
            control={
              <Switch
                checked={question.isEncrypted}
                onChange={(e) => onChange("isEncrypted", e.target.checked)}
              />
            }
            label={
              <Typography variant="body1" fontWeight={"regular"}>
                Encrypt Response
              </Typography>
            }
          />
        </Stack>
      )}

      {![
        "statement",
        "summary",
        "randomize",
        "eligibility",
        "repeated_measure",
      ].includes(question.type) && (
        <Stack gap={1}>
          <FormControlLabel
            disabled={isPreview}
            control={
              <Switch
                checked={question.excludeExport}
                onChange={(e) => onChange("excludeExport", e.target.checked)}
              />
            }
            label={
              <Typography variant="body1" fontWeight={"regular"}>
                Exclude in Export
              </Typography>
            }
          />
        </Stack>
      )}
      {(!no_validation_types.includes(question.type) ||
        ["address"].includes(question.type)) &&
        formLevel === "platform" && (
          <ProfileAttribute
            onChange={onChange}
            question={question}
            isPreview={isPreview}
            type={question.type}
          />
        )}
      {formLevel === "platform" && (
        <CanonicalQuestionMapper
          question={question}
          onChange={onChange}
          isPreview={isPreview}
        />
      )}
    </Stack>
  );
};
